module.exports = __webpack_public_path__ + "img/interational_truck_img_1.330cdcdd.png";